import { ChevronLeft } from 'react-feather';
import { Link } from 'react-router-dom';

import Button from '@/shared/components/UI/Button';
import { NavInnerProps } from '@/shared/types/NavTypes';

const NavInner = ({
  setIsNavOpen,
  title,
  // categoryData,
  // artistCategoryData,
  childrenData,
}: NavInnerProps) => {
  return (
    <div className="absolute left-1/2 z-20 flex w-[1024px] -translate-x-1/2 flex-col justify-center rounded-b-2xl border-t-[1px] bg-white px-0 py-8">
      <Button
        type="button"
        variant="ghost"
        onClick={() => setIsNavOpen(false)}
        leftIcon={<ChevronLeft size={20} />}
        className="mb-8 h-auto items-center justify-start gap-3 text-[10px] font-semibold text-[#666]"
      >
        {title}
      </Button>
      <ul className="grid w-full grid-cols-3 justify-items-center gap-y-3">
        {childrenData?.map((child) => (
          <Link
            to={`/productlist/${child.category ? `${child.id}?categoryName=${child.category}` : `0?artistId=${child.id}&artistName=${child.artistNameEN} | ${child.artistNameKO}`}`}
            key={child.id}
            className="flex h-7 cursor-pointer items-center justify-center text-[10px] font-semibold text-[#777]"
          >
            {child.category
              ? child.category
              : `${child.artistNameKO} | ${child.artistNameEN}`}
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default NavInner;
